import * as e from "react";
import c from "../lib/SSRBase.es.js";
import a from "../defs/ShieldCheck.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(c, { ref: t, ...r, weights: a }));
o.displayName = "ShieldCheckIcon";
const h = o;
export {
  h as ShieldCheck,
  o as ShieldCheckIcon
};
